import { render, staticRenderFns } from "./IconRewardTotalRedeemPoint.vue?vue&type=template&id=4f52f762"
import script from "./IconRewardTotalRedeemPoint.vue?vue&type=script&lang=js"
export * from "./IconRewardTotalRedeemPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports